<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="sass">

html,
body,
#app,
.admin
  font-family: 'Montserrat', sans-serif
  background-color: #F1F1F1
  height: 100%
  width: 100%
  margin: 0px
  padding: 0px

@import url('https://fonts.googleapis.com/css?family=Montserrat:100,400,600,700')

.bulma
  @import "../node_modules/bulma/bulma"
  *
    box-sizing: border-box

.bulmalux
  @import "../node_modules/bulmaswatch/lux/_variables.scss"
  @import "../node_modules/bulma/bulma"
  @import "../node_modules/bulmaswatch/lux/_overrides.scss"
  *
    box-sizing: border-box

</style>



// WEBPACK FOOTER //
// src/App.vue